import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { findPayrollStartAndEndDates } from '../helpers/payroll';
import { getUsersFromSelectedDivisions } from './timecard.helpers';
import { updateCurrentTimeEntriesRange } from './state/timecards.actions';
import TimeTracking from '../state/timeTracking';
import { compareStringArrays } from '../helpers/helpers';

import Debouncer from '../helpers/Debouncer';

const debouncer = new Debouncer();
const userWasAdded = (oldArr, newArr) => {
  if (!newArr?.length) return false;
  const {
    added,
  } = compareStringArrays(oldArr, newArr);
  return added?.length > 0;
};

function DivisionTimeEntriesGetter() {
  const dispatch = useDispatch();

  const firstPayrollDay = useSelector((state) => state.timecards.firstPayrollDay);
  const payPeriod = useSelector((state) => state.timecards.payPeriod);
  const semiMonthlyPayPeriodDates = useSelector((state) => (
    state.timecards.semiMonthlyPayPeriodDates
  ));
  const users = useSelector((state) => state.users.users);
  const selectedDivisions = useSelector((state) => state.settings.selectedDivisions);
  const divisions = useSelector((state) => state.settings.divisions);

  const [prevStart, setPrevStart] = useState(null);
  const [prevEnd, setPrevEnd] = useState(null);
  const [prevIds, setPrevIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const [
    payPeriodStart,
    payPeriodEnd,
  ] = useMemo(() => (
    findPayrollStartAndEndDates({
      payPeriodFirstDay: firstPayrollDay,
      payPeriod,
      semiMonthlyPayPeriodDates,
    })
  ), [firstPayrollDay, payPeriod, semiMonthlyPayPeriodDates]);

  const userIds = useMemo(() => (
    getUsersFromSelectedDivisions({
      users,
      selectedDivisions,
      divisions,
    }).map((u) => u.id)
  ), [users, selectedDivisions, divisions]);

  const getEntries = async () => {
    if (loading || !userIds.length) return;
    setLoading(true);
    await dispatch(TimeTracking.getTimeEntries({
      startTime: payPeriodStart.toMillis(),
      endTime: payPeriodEnd.toMillis(),
      getRunningTasks: true,
      userIds,
      getCardDetails: true,
    }));
    await dispatch(updateCurrentTimeEntriesRange(payPeriodStart, payPeriodEnd));
    setPrevStart(payPeriodStart.toMillis());
    setPrevEnd(payPeriodEnd.toMillis());
    setPrevIds(userIds);
    setLoading(false);
  };

  if (
    prevStart !== payPeriodStart.toMillis()
    || prevEnd !== payPeriodEnd.toMillis()
    || userWasAdded(prevIds, userIds)
  ) {
    debouncer.debounce(getEntries, 2000);
  }
  return null;
}

export default DivisionTimeEntriesGetter;
